<form [formGroup]="formGroup">
  <div class="mydocma-form-field-wrapper">
    <div class="mydocma-form">
      <mat-slide-toggle matInput [formControlName]="'isAssigned'"
                        (change)="onToggleChanged($event)">
      </mat-slide-toggle>
    </div>
  </div>
</form>
